import React, { useEffect, useState } from "react";
import { isNotValidNullUndefile } from "../control/Constant";
import AoUrl from "../network/url";
import { Services } from "../network/Services";
import Loader from "./Loader";

const withOccurrenceApi = (WrappedComponent, occurrenceId) => {
  return (props) => {

    /* =====================
       STATE
    ===================== */
    const [emailObj, setEmailObj] = useState({ emailTempData: "", emailTemp: "" });
    const [textObj, setTextObj] = useState({ textTempData: "", textTemp: "" });
    const [commChannelId, setCommChannelId] = useState("");
    const [useLoader, setUseLoader] = useState(false);

    const [_subtenantId, setSubtenantId] = useState("");

    /* =====================
       EFFECT
    ===================== */
    useEffect(() => {
      const subId = sessionStorage.getItem("SubtenantId");
      setSubtenantId(subId);

      if (isNotValidNullUndefile(subId)) {
        fetchApi(subId);
      }
    }, [occurrenceId]);

    /* =====================
       API HELPERS
    ===================== */
    const getApiCall = async (method, url) => {
      try {
        const res = await Services.getCommonApi(method, url, "");
        return res?.data?.data || [];
      } catch {
        return "err";
      }
    };

    // const postApiCall = async (method, url, payload) => {
    //   try {
    //     const res = await Services.getCommonApi(method, url, payload);
    //     return res?.data?.data || "err";
    //   } catch {
    //     return "err";
    //   }
    // };

    const postApiCall = (method, url, payload) => {
  return new Promise((resolve, reject) => {
    Services.getCommonApi(method, url, payload)
      .then((res) => {
        if (res?.data?.data) {
          resolve(res.data.data);
        } else {
          resolve("err");
        }
      })
      .catch((error) => {
        resolve("err"); // keeping same behavior as your async version
      });
  });
};






    /* =====================
       FETCH API
    ===================== */
    const fetchApi = async (subtenantId) => {
      setUseLoader(true);

      const payload = {
        occurrenceId,
        isActive: true,
        subtenantId,
      };

      const result = await postApiCall("POST", AoUrl.getCommMediumPath, payload);

      if (!Array.isArray(result) || !result.length) {
        setUseLoader(false);
        return;
      }

      const {
        commChannelId,
        applicableTextTempId,
        applicableEmailTempId,
        isActive,
      } = result[0];

      setCommChannelId(commChannelId);

      const textUrl = `${AoUrl.getTextTemplate}?TextTemplateId=${applicableTextTempId}&IsActive=${isActive}&SubtenantId=${subtenantId}`;
      const emailUrl = `${AoUrl.GetEmailTemplate}?TemplateId=${applicableEmailTempId}&IsActive=${isActive}&SubtenantId=${subtenantId}`;

      if (commChannelId === 1 || commChannelId === 3) {
        const emailRes = await getApiCall("GET", emailUrl);
        if (emailRes?.length) {
          setEmailObj({
            emailTempData: emailRes,
            emailTemp: emailRes[0].templateContent,
          });
        }
      }

      if (commChannelId === 2 || commChannelId === 3) {
        const textRes = await getApiCall("GET", textUrl);
        if (textRes?.length) {
          setTextObj({
            textTempData: textRes,
            textTemp: textRes[0].textTemplateContent,
          });
        }
      }

      setUseLoader(false);
    };

    /* =====================
       SEND MAIL / TEXT
    ===================== */
      const sentMail = async (emailJson, mobileJson) => {
          return new Promise(async (resolve, reject) => {

              setUseLoader(true);;
              if (commChannelId === 2 && isNotValidNullUndefile(mobileJson?.textTo)) {
                  const _resultTextSent = await postApiCall('POST', AoUrl.postSendTextPath, mobileJson);
                 setUseLoader(false);
                  resolve('resolve');
              } else if (commChannelId === 1) {
                  const _resultEmailSent = await postApiCall('POST', AoUrl.sentEmailWithAsyncCcBc, emailJson);
                  setUseLoader(false);
                  resolve('resolve');
              } else {
                  const _resultEmailSent = await postApiCall('POST', AoUrl.sentEmailWithAsyncCcBc, emailJson);
                  if (isNotValidNullUndefile(mobileJson?.textTo)) {
                      const _resultTextSent = await postApiCall('POST', AoUrl.postSendTextPath, mobileJson);
                      resolve('resolve');
                  } else {
                      resolve('resolve');
                  }
              }

              setUseLoader(false);;
              resolve('resolve');
          })
      };

    /* =====================
       RENDER
    ===================== */
    return (
      <>
        {useLoader && <Loader useLoader={useLoader} />}
        <WrappedComponent
          {...props}
          emailTmpObj={emailObj}
          textTmpObj={textObj}
          sentMail={sentMail}
          commChannelId={commChannelId}
        />
      </>
    );
  };
};

export default withOccurrenceApi;

